/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useMutation } from '@apollo/client';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { SET_CORREIOS_CREDENTIALS } from './graphql';

export function useSetCorreiosCredentials() {
  const { setLoading, setErrorMessage, setSuccessMessage } =
    useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [SetCorreiosCredentials, { loading: apiLoading }] = useMutation(
    SET_CORREIOS_CREDENTIALS,
    { fetchPolicy: 'network-only' },
  );

  useEffect(() => {
    if (apiLoading) {
      setIsLoading(true);
      setLoading(true);
    } else {
      setIsLoading(false);
      setLoading(false);
    }
  }, [apiLoading]);

  async function setCorreiosCredentials({ storeId, credentials }) {
    try {
      const res = await SetCorreiosCredentials({
        variables: { credentials: { ...credentials, storeId } },
      });
      if (res.data.setCorreiosCredentials.code === 201) {
        setSuccessMessage('Credenciais salvas com sucesso!');
      } else {
        setErrorMessage('Erro ao linkar conta verifique os dados digitados');
      }
    } catch (e) {
      setErrorMessage('Algo deu errado, tente novamente mais tarde.');
    }
  }

  return {
    setCorreiosCredentials,
    loading: isLoading,
  };
}
